import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=29a670de&scoped=true&"
import script from "./PageEdit.vue?vue&type=script&lang=js&"
export * from "./PageEdit.vue?vue&type=script&lang=js&"
import style0 from "./PageEdit.vue?vue&type=style&index=0&id=29a670de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a670de",
  null
  
)

export default component.exports